import { useParams } from "react-router-dom";
import fileDownload from "js-file-download";
import { FaDownload } from "react-icons/fa6";
import { useMaterialFile } from "../hooks/useMaterialFile";

import { Skeleton, Stack } from "@mui/material";
import Button from "@/components/Button";

function MaterialItem({ itemData, id }) {
    const { courseId, lectureId } = useParams();

    const { name, file } = itemData;
    const fileExtention = file?.split(".")[1];

    const { isPending, materialFile } = useMaterialFile({
        courseId,
        lectureId,
        materialId: id,
    });

    if (isPending)
        return (
            <div className="flex items-center justify-between gap-4">
                <Stack spacing={1} className="w-full">
                    <Skeleton
                        variant="rounded"
                        height={52}
                        className="w-full"
                    />
                </Stack>
                <Stack spacing={1} className="w-fit">
                    <Skeleton
                        variant="rounded"
                        height={52}
                        className="w-[50px]"
                    />
                </Stack>
            </div>
        );

    return (
        <li className="flex items-center justify-between gap-4">
            <div className="flex gap-3 bg-white py-2.5 w-full rounded-lg">
                <img
                    src={
                        fileExtention === "pdf"
                            ? "/images/courses/pdfIcon.webp"
                            : "/images/courses/imageIcon.webp"
                    }
                    loading="lazy"
                    alt="file type Icon"
                    decoding="async"
                />
                <span className="text-lg font-medium text-secondary-color">
                    {name}.{fileExtention}
                </span>
            </div>
            <Button
                type="customized"
                className="p-2.5 rounded-lg bg-secondary-color"
                onClick={() => {
                    fileDownload(materialFile, `${name}.${fileExtention}`);
                }}
                name="download material item button"
            >
                <FaDownload className="text-lg text-white" />
            </Button>
        </li>
    );
}

export default MaterialItem;
